<template>
  <div class="columns is-multiline">
    <div class="column is-4-desktop is-2-fullhd is-cursor-pointer" v-for="(recapMontant, index)
    in getAllModeReglementRecap" :key="index">
      <div class="card-content has-background-white"
           :class="{'card-outline-primary' : isSelected(recapMontant.actionAchat,
           recapMontant.bap) }"
           @click="$emit('updateFilters', recapMontant)">
        <div class="columns">
          <div class="column is-6 pdr-0 pdl-0">
            <p class="ellipsis">
              <b-icon
                icon="circle"
                size="is-small"
                :type="recapMontant.colorRond">
              </b-icon>
              {{ recapMontant.bap ? $t('listeEcheancesAPayer.cumul.bap',
              { libelle: $t(recapMontant.libelle) })
              : $t('listeEcheancesAPayer.cumul.total', { libelle: $t(recapMontant.libelle) }) }}
            </p>
          </div>
          <div class="column is-6 pdr-0">
          <p class="has-text-weight-bold ellipsis has-text-right">
          {{ recapMontant.montant | formatDevise }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { LISTE_ACTION_ACHAT } from '@/configuration/parametrage/modeReglementConf';
import { COLORS_CUMUL } from '@/configuration/baux/echeancesAPayer/echeancesAPayerConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    listePaiement: {
      required: true,
      type: Array,
    },
    surFacture: {
      required: false,
      type: Boolean,
      default: false,
    },
    criteresRecherche: {
      required: true,
      type: Object,
    },
    cumulByTypeActionAchat: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getAllModeReglementRecap() {
      const recapPaiement = [
        {
          colorRond: COLORS_CUMUL[0].fonce,
          libelle: LISTE_ACTION_ACHAT[1].libelle,
          actionAchat: LISTE_ACTION_ACHAT[1].code,
          bap: null,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[1].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatLettreCheque,
        },
        {
          colorRond: COLORS_CUMUL[1].fonce,
          libelle: LISTE_ACTION_ACHAT[2].libelle,
          actionAchat: LISTE_ACTION_ACHAT[2].code,
          bap: null,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[2].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatVirement,
        },
        {
          colorRond: COLORS_CUMUL[2].fonce,
          libelle: LISTE_ACTION_ACHAT[3].libelle,
          actionAchat: LISTE_ACTION_ACHAT[3].code,
          bap: null,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[3].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatAutre,
        },
        {
          colorRond: COLORS_CUMUL[0].clair,
          libelle: LISTE_ACTION_ACHAT[1].libelle,
          actionAchat: LISTE_ACTION_ACHAT[1].code,
          bap: true,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[1].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatLettreChequeBonAPayer,
        },
        {
          colorRond: COLORS_CUMUL[1].clair,
          libelle: LISTE_ACTION_ACHAT[2].libelle,
          actionAchat: LISTE_ACTION_ACHAT[2].code,
          bap: true,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[2].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatVirementBonAPayer,
        },
        {
          colorRond: COLORS_CUMUL[2].clair,
          libelle: LISTE_ACTION_ACHAT[3].libelle,
          actionAchat: LISTE_ACTION_ACHAT[3].code,
          bap: true,
          numberModeReglement: this.getNombreReglementByActionAchat(LISTE_ACTION_ACHAT[3].code),
          montant: this.cumulByTypeActionAchat.montantTotalActionAchatAutreBonAPayer,
        },
      ];
      return recapPaiement.filter((recap) => { return recap.numberModeReglement > 0; });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getNombreReglementByActionAchat(actionAchat) {
      return this.parametre(PARAMETRES_KEYS.modeReglement)
        .filter((modeReglement) => { return modeReglement.actionAchat === actionAchat; }).length;
    },
    isSelected(actionAchat, bap) {
      const modeReglementByActionAchat = this.parametre(PARAMETRES_KEYS.modeReglement)
        .filter((modeReglement) => {
          return modeReglement.actionAchat === actionAchat;
        });
      if ((modeReglementByActionAchat.length !== this.criteresRecherche.modesReglementsIds.length)
        || modeReglementByActionAchat.length === 0) {
        return false;
      }

      let hasError = false;
      this.criteresRecherche.modesReglementsIds.forEach((modeReglementFiltre) => {
        const isIntoActionAchat = modeReglementByActionAchat.find((modeReglement) => {
          return modeReglement.id === modeReglementFiltre;
        });
        if (isIntoActionAchat === undefined) hasError = true;
      });
      if (hasError) return false;

      return bap === this.criteresRecherche.bonAPayer;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
